import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// eslint-disable-next-line
// @ts-expect-error
import font from '../../fonts/pt_sans/pt_sans-regular.ttf';
var fontsRequested = false;
export function requestFonts() {
  return _requestFonts.apply(this, arguments);
}

function _requestFonts() {
  _requestFonts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fontFile;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!fontsRequested) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            fontsRequested = true;
            fontFile = new FontFace('PTSans', "url(".concat(font, ")"), {
              weight: '300',
              style: 'normal'
            });
            _context.next = 6;
            return document.fonts.ready;

          case 6:
            // eslint-disable-next-line
            // @ts-expect-error
            document.fonts.add(fontFile);
            fontFile.load();

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _requestFonts.apply(this, arguments);
}